// import { createSelector } from 'reselect';
export const getIsPosting = state => state.getIn(['registration', 'isPosting']);
export const getErrMsg = state => state.getIn(['registration', 'errMsg']);